export const partners =  [
    {
     name: "none",
     displayName: "Brak",
   },
   {
     name: "luxmed",
     displayName: "Luxmed",
   },
   {
     name: "asekuro",
     displayName: "Asekuro",
   },
   {
     name: "mdt",
     displayName: "MDT",
   },
  
 ]